var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconName)?_c('svg',{staticClass:"icon",class:_vm.className,attrs:{"aria-hidden":"false"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }